import { createReducer, on } from '@ngrx/store';
import { MessageResponse } from 'src/app/models/message-response.model';
import * as fromSupportChatActions from '../../actions/messages/messages.actions';

export const messagesFeatureKey = 'messages';

export interface State {
  messages: any;
  messageDetails: any;
}

export const initialState: State = {
  messages: null,
  messageDetails: null
};

export const reducer = createReducer(
  initialState,
  on(fromSupportChatActions.loadMessagesSuccess, (state, action) => {
    let messageDetails = state.messageDetails;
    let messages: MessageResponse[] = [];
    action.messages?.forEach(message => {
      if (messageDetails) {
        if (message.id === messageDetails.id) {
          let readMessage = { ...message, read: messageDetails.read };
          messages.push(readMessage);
        } else messages.push(message);
      } else messages.push(message);
    });
    return {
      ...state,
      messages: messages
    };
  }),
  on(fromSupportChatActions.setMessageDetails, (state, action) => {
    return {
      ...state,
      messageDetails: action.messageDetails
    };
  }),
  on(fromSupportChatActions.updateMessageDetails, (state, action) => {
    let messageDetails = { ...state.messageDetails, read: action.read };
    let messages: MessageResponse[] = [];
    state.messages?.forEach((message: any) => {
      if (messageDetails) {
        if (message.id === messageDetails.id) {
          let readMessage = { ...message, read: messageDetails.read };
          messages.push(readMessage);
        } else messages.push(message);
      } else messages.push(message);
    });
    return {
      ...state,
      messages: messages,
      messageDetails: messageDetails
    };
  }),
  on(fromSupportChatActions.resetMessageDetails, state => {
    return {
      ...state,
      messageDetails: null
    };
  })
);
